var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordVisibilityOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.918,
    height: 18.707,
    viewBox: "0 0 22.918 18.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4356",
    "data-name": "Group 4356",
    transform: "translate(-1297.043 -532.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M18937.459-8946.855a14.8,14.8,0,0,1-8.1-2.865,20.983,20.983,0,0,1-3.355-2.863l.006-.012a21.4,21.4,0,0,1,4.828-3.786l3.758,3.758v.038a2.868,2.868,0,0,0,2.867,2.863h.033l2.561,2.56A11.422,11.422,0,0,1,18937.459-8946.855Zm6.627-1.935h0l-3.764-3.763v-.033a2.866,2.866,0,0,0-2.863-2.863h-.031l-2.561-2.56a11.405,11.405,0,0,1,2.592-.309,14.8,14.8,0,0,1,8.1,2.865,20.935,20.935,0,0,1,3.355,2.863l-.006.012a21.4,21.4,0,0,1-4.826,3.786Z",
    transform: "translate(-17628.957 9494.088)",
    fill: "#072f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M18944.707-8942.878h0l-17.295-17.295,1.418-1.412,17.289,17.29-1.412,1.417Z",
    transform: "translate(-17628.266 9493.732)",
    fill: "#072f33"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisibilityOff);
export default __webpack_public_path__ + "static/media/Password_Visibility_Off.28ed8e7c474bd20cdca1f8683e646d92.svg";
export { ForwardRef as ReactComponent };